import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 font-label text-xs font-semibold uppercase tracking-wide text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-extrabold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action}
    </div>
  );
}